import { NARRATION_PROVIDERS, type NarrationProviderCode } from './constants';

// ナレーション (TTS) の音声AIモデルの最後の選択を保持する localStorage キー。
// BGM の bgm_provider_last と同じく、シナリオ横断のグローバル設定として扱う。
export const NARRATION_PROVIDER_KEY = 'narration_provider_last';

export function readStoredNarrationProvider(): NarrationProviderCode {
  try {
    const v = localStorage.getItem(NARRATION_PROVIDER_KEY);
    if ((NARRATION_PROVIDERS as readonly string[]).includes(v ?? '')) return v as NarrationProviderCode;
  } catch { /* ignore */ }
  return 'gemini';
}

export function writeStoredNarrationProvider(provider: NarrationProviderCode): void {
  try { localStorage.setItem(NARRATION_PROVIDER_KEY, provider); } catch { /* ignore */ }
}
